import { aanpAuthOptions } from "./util";
import { apiUrl } from "../config";
import instance from "./instance";

export function getApplicationSettings() {
    return instance.get(`${apiUrl}/configuration/getApplicationSettings`, aanpAuthOptions()).then((r) => r.data);
  }

  export function getInternationalCountries() {
    return instance.get(`${apiUrl}/configuration/getInternationalCountries/`, aanpAuthOptions()).then((r) => r.data);
  }

  export function getInternationalPreferredCountries() {
    return instance.get(`${apiUrl}/configuration/getInternationalPreferredCountries/`, aanpAuthOptions()).then((r) => r.data);
  }

  export function getInternationalCountriesWithStates() {
    return instance.get(`${apiUrl}/configuration/getInternationalCountriesWithStates/`, aanpAuthOptions()).then((r) => r.data);
  }

  export function getInternationalStates(countryName) {
    return instance.get(`${apiUrl}/configuration/getInternationalStates?countryName=${countryName}`, aanpAuthOptions()).then((r) => r.data);
  }